<template>
  <div class="home-container">
    <div class="home-header-sticky">
      <!-- 自定义精致 Tab 切换 -->
      <div class="home-tab-nav">
        <div class="tab-nav-wrapper">
          <div class="tab-item" @click="switchTab(0)">
            <img
              :src="currentTab === 0 ? require('@/assets/home/home_tab_product_sel.png') : require('@/assets/home/home_tab_product_nor.png')"
              class="tab-icon-img"
            />
          </div>
          <div class="tab-item" @click="switchTab(1)">
            <img
              :src="currentTab === 1 ? require('@/assets/home/home_tab_material_sel.png') : require('@/assets/home/home_tab_material_nor.png')"
              class="tab-icon-img"
            />
          </div>
        </div>
      </div>

      <!-- 顶部搜索栏 -->
      <search-bar
        v-show="currentTab === 0"
        :hot-search-list="hotSearchList"
        :cart-count="cartCount"
        :msgtotal-count="msgtotalCount"
      />
    </div>

    <!-- 页面内容容器 -->
    <div class="home-main-content" :class="{ 'material-tab-active': currentTab === 1 }">
      <!-- 商品大模块 -->
      <home-product
        v-show="currentTab === 0"
        ref="homeProduct"
        @updateHotSearch="onUpdateHotSearch"
        @updateCount="onUpdateCount"
        @showPoster="onShowPoster"
      />

      <!-- 素材圈 -->
      <material-circle
        v-show="currentTab === 1"
        ref="materialCircle"
        :container-height="containerHeight"
      />
    </div>

    <!-- 公告弹窗 Overlay -->
    <van-overlay
      :show="publickTell.isShow === 1 && !!publickTell.imgUrl"
      z-index="99"
      @click="closeNotice"
    >
      <div class="notice-dialog" @click.stop>
        <img :src="publickTell.imgUrl" class="notice-image" />
        <div class="notice-close" @click="closeNotice">×</div>
      </div>
    </van-overlay>

    <!-- 首页广告弹窗 Overlay -->
    <van-overlay
      :show="showHomeAd && !!homePageDialog.imageUrl"
      z-index="99"
      @click="closeHomeAd"
    >
      <div class="ad-dialog" @click.stop>
        <img :src="homePageDialog.imageUrl" class="ad-img-content" @click="onAdDialogClick" />
        <div class="ad-close-btn" @click="closeHomeAd">
          <van-icon name="close" />
        </div>
      </div>
    </van-overlay>

    <!-- 原有海报弹窗与微信分享蒙层 -->
    <poster
      v-if="showPoster"
      :show="showPoster"
      :posterItem="posterItem"
      @closePoster="closePoster"
      @openShare="openShare"
    />
    <share-mask v-if="showShareMask" @hideMask="hideMask" />
  </div>
</template>

<script>
import SearchBar from "./components/SearchBar.vue";
import HomeProduct from "./components/HomeProduct.vue";
import MaterialCircle from "./components/MaterialCircle.vue";
import Poster from "../product/detail/components/Poster";
import ShareMask from "../mine/cardvoucher/components/ShareMask";
import { loadNotice, getHomePageDialog } from "@/api/home";

export default {
  name: "Home",
  components: {
    SearchBar,
    HomeProduct,
    MaterialCircle,
    Poster,
    ShareMask
  },
  data() {
    return {
      currentTab: 0,
      hotSearchList: [],
      cartCount: 0,
      msgtotalCount: 0,
      containerHeight: 0,
      
      // 公告与广告弹窗
      publickTell: {
        isShow: 0,
        imgUrl: ""
      },
      homePageDialog: {
        enableShowDialog: false,
        imageUrl: "",
        forwardType: 4,
        forwardDetail: ""
      },
      showHomeAd: false,

      // 海报和分享
      showPoster: false,
      showShareMask: false,
      posterItem: {},
      lastScrollTop: 0
    };
  },
  created() {
    this.checkNotice();
    this.checkHomePageDialog();
  },
  mounted() {
    this.calculateHeight();
    window.addEventListener("resize", this.calculateHeight);
  },
  activated() {
    this.calculateHeight();
    window.addEventListener("resize", this.calculateHeight);
    if (this.lastScrollTop) {
      this.$nextTick(() => {
        document.documentElement.scrollTop = this.lastScrollTop;
        document.body.scrollTop = this.lastScrollTop;
      });
    }
  },
  deactivated() {
    window.removeEventListener("resize", this.calculateHeight);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.calculateHeight);
  },
  beforeRouteLeave(to, from, next) {
    this.lastScrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    next();
  },
  methods: {
    calculateHeight() {
      // 屏幕总高减去搜索栏 52px 和 tab 栏 44px
      this.containerHeight = window.innerHeight - 96;
    },
    switchTab(index) {
      if (this.currentTab === index) return;
      this.currentTab = index;
      
      // 如果切换到素材圈，触发其初始化加载
      if (index === 1 && this.$refs.materialCircle) {
        this.$refs.materialCircle.loadMaterial(true);
      }
    },
    onUpdateHotSearch(list) {
      this.hotSearchList = list;
    },
    onUpdateCount(data) {
      this.cartCount = data.cartCount;
      this.msgtotalCount = data.msgtotalCount;
    },
    
    // 检查公告
    async checkNotice() {
      const today = this.getTodayString();
      const lastShow = localStorage.getItem("notice_last_show");
      if (lastShow === today) return;

      try {
        const res = await loadNotice(1, { slug: this.slug });
        if (res && res.isShow === 1) {
          localStorage.setItem("notice_last_show", today);
          this.publickTell = res;
        }
      } catch (err) {
        console.error("加载公告失败", err);
      }
    },

    // 检查首页弹窗
    async checkHomePageDialog() {
      const today = this.getTodayString();
      const lastShow = localStorage.getItem("home_dialog_last_show");
      if (lastShow === today) return;

      try {
        const res = await getHomePageDialog({ slug: this.slug });
        if (res && res.enableShowDialog) {
          localStorage.setItem("home_dialog_last_show", today);
          this.homePageDialog = res;
          this.showHomeAd = true;
        }
      } catch (err) {
        console.error("加载首页弹窗失败", err);
      }
    },

    getTodayString() {
      const now = new Date();
      return `${now.getFullYear()}-${now.getMonth() + 1}-${now.getDate()}`;
    },

    closeNotice() {
      this.publickTell.isShow = 0;
    },

    closeHomeAd() {
      this.showHomeAd = false;
    },

    onAdDialogClick() {
      this.showHomeAd = false;
      if (this.$refs.homeProduct) {
        this.$refs.homeProduct.adJumpTo(this.homePageDialog);
      }
    },

    // 海报与分享
    onShowPoster(item) {
      this.$router.push({
        path: "/product/share",
        query: { id: item.id }
      });
    },
    closePoster() {
      this.showPoster = false;
    },
    hideMask() {
      this.showShareMask = false;
    },
    isWechatBrowser() {
      const ua = navigator.userAgent.toLowerCase();
      return ua.indexOf("micromessenger") !== -1;
    },
    openShare() {
      if (this.isWechatBrowser()) {
        this.showPoster = false;
        this.showShareMask = true;
      } else {
        this.$toast("请在微信内打开以分享朋友圈");
      }
    }
  }
};
</script>

<style lang="less" scoped>
.home-container {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #f7f8fa;
}

.home-header-sticky {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 99;
  background-color: #fff;
  border-bottom: 1px solid #f2f3f5;
}

// 导航 Tab 样式
.home-tab-nav {
  display: flex;
  align-items: center;
  height: 44px;
  background-color: #fff;
  padding: 0 16px;
}
.tab-nav-wrapper {
  display: flex;
  align-items: center;
  height: 100%;
  gap: 16px;
}
.tab-item {
  display: flex;
  align-items: center;
  height: 100%;
  cursor: pointer;
  .tab-icon-img {
    height: 22px;
    width: auto;
    display: block;
  }
}

.home-main-content {
  flex: 1;
  width: 100%;
  padding-top: 96px;
  &.material-tab-active {
    padding-top: 44px;
  }
}

// 公告弹窗
.notice-dialog {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 280px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .notice-image {
    width: 100%;
    border-radius: 8px;
    object-fit: contain;
  }
  .notice-close {
    margin-top: 16px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    border: 1px solid #fff;
    color: #fff;
    font-size: 24px;
    line-height: 28px;
    text-align: center;
    cursor: pointer;
  }
}

// 广告弹窗
.ad-dialog {
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 290px;
  display: flex;
  flex-direction: column;
  align-items: center;
  .ad-img-content {
    width: 100%;
    border-radius: 12px;
    object-fit: contain;
    cursor: pointer;
  }
  .ad-close-btn {
    margin-top: 20px;
    color: #fff;
    font-size: 32px;
    cursor: pointer;
  }
}
</style>
